// extracted by mini-css-extract-plugin
export default {"root":"wR1eGX","line":"G0NIUK"};